import { ElMessageBox,ElMessage } from "element-plus";
import { getLoginVisitorUpgrade } from "@/api/request/login";
import store from "@/store";
import { getDictList } from "@/api/request";
import { postStudentSubjectInfo } from "@/api/request/user";
import { i18n } from "@/language/local";
import type { Action } from "element-plus";
import { 
  getVisitorSurvey
} from "@/api/request/user";
/**
 * 复制文本到粘贴板
 * @param textValue string
 * @returns Promise
 */
export function copyText(textValue: string) {
  return new Promise<boolean>((resolve, reject) => {
    // 优先使用现代的Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      // 在安全上下文（HTTPS）中使用
      navigator.clipboard.writeText(textValue)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          // 现代方法失败，回退到传统方法
          fallbackCopyTextToClipboard(textValue, resolve, reject);
        });
    } else {
      // 不支持现代方法或非安全上下文，使用传统方法
      fallbackCopyTextToClipboard(textValue, resolve, reject);
    }
  });
}

/**
 * 传统的复制方法（作为fallback）
 */
function fallbackCopyTextToClipboard(textValue: string, resolve: (value: boolean) => void, reject: (reason: boolean) => void) {
  // 动态创建 textarea 标签
  const textarea = document.createElement("textarea");
  // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
  textarea.readOnly = true;
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  // 将要 copy 的值赋给 textarea 标签的 value 属性
  textarea.value = textValue;
  // 将 textarea 插入到 body 中
  document.body.appendChild(textarea);
  // 选中值并复制
  textarea.select();
  const result = document.execCommand("Copy");
  document.body.removeChild(textarea);
  
  if (result) {
    resolve(true);
  } else {
    reject(false);
  }
}

/** 强制刷新当前页面 */
export function refreshPage(msg?: string) {
  ElMessageBox.alert(
    msg || i18n.global.t("认证信息数据异常，请刷新重试"),
    i18n.global.t("提示"),
    {
      showClose: false,
      closeOnHashChange: false,
      confirmButtonText: i18n.global.t("刷新页面"),
      confirmButtonClass: "g-redBtn",
      callback: () => {
        window.location.reload();
      },
    }
  );
}
/** 升级游客到正式账户 */
export function upgradeAccount(data?: { isCert?: boolean,userType?: string }) {
  // 如果是认证相关游客 需要同时验证localStorage的VUE_APP_VISITOR标识和用户类型
  // 否则不需要验证localStorage的VUE_APP_VISITOR
  // 因为认证服务商报名后 会清空localStorage的VUE_APP_VISITOR标识
  // 但是用户信息还是存在的
  if (
    data?.isCert &&
    localStorage.getItem(process.env.VUE_APP_VISITOR) &&
    store.state.user.userInfo.type === "0"
  ) {
    return new Promise<{ status: "confirm" | "cancel" | "close" | "ok" }>(
      (resolve, reject) => {
        ElMessageBox.confirm(
          i18n.global.t("当前账号不支持此功能，请升级账号信息！"),
          i18n.global.t("提示"),
          {
            distinguishCancelAndClose: data?.isCert,
            confirmButtonText: i18n.global.t("去升级"),
            cancelButtonText: i18n.global.t("素材服务商身份报名"),
            type: "warning",
            lockScroll: false,
          }
        )
          .then(() => {
            getLoginVisitorUpgrade().then(() => {
              // store.dispatch("Login");
              // window.open(
              //   "https://wj.byteoversea.com/q/64377/7z6vI381/eda3/#/"
              // );
              //判断是否填写过问卷调查
              getVisitorSurvey().then((res) => {
                if(res.data){
                    ElMessage.warning("您已经填写过问卷调查了，感谢您的参与！");
                    resolve({
                      status: "ok",
                    });
                }else{ 
                    resolve({
                      status: "confirm",
                    });
                }
              })
            });
          })
          .catch((action: Action) => {
            // reject();
            console.log("action", action);
            resolve({
              status: action,
            });
          });
      }
    );
  } else if (!data?.isCert && store.state.user.userInfo.type === "0" && data?.userType === "0") {  //游客点击课程目录中的非视听课  先提示升级账号  升级账号后再判断是否填写过问卷调查
    return new Promise<{ status: "confirm" | "cancel" | "close"| "ok" }>(
      (resolve, reject) => {

        ElMessageBox.confirm(
                i18n.global.t("当前账号不支持此功能，请升级账号信息！"),
                i18n.global.t("提示"),
                {
                  distinguishCancelAndClose: data?.isCert,
                  confirmButtonText: i18n.global.t("去升级"),
                  cancelButtonText: i18n.global.t("知道了"),
                  type: "warning",
                  lockScroll: false,
                }
              )
                .then(() => {
                  getLoginVisitorUpgrade().then(() => {
                    // store.dispatch("Login");
                    // window.open(
                    //   "https://wj.byteoversea.com/q/64377/7z6vI381/eda3/#/"
                    // );
                     //判断是否填写过问卷调查
                      getVisitorSurvey().then((res) => {
                        if(res.data){
                            ElMessage.warning("您已经填写过问卷调查了，感谢您的参与！");
                            resolve({
                              status: "ok",
                            });
                        }else{ 
                            resolve({
                              status: "confirm",
                            });
                        }
                      })
                  });
                })
                .catch((action: Action) => {
                  // reject();
                  console.log("action", action);
                  resolve({
                    status: action,
                  });
                });
 
      }
    );
  } else if (!data?.isCert && store.state.user.userInfo.type === "0") {  //先判断后弹窗
    return new Promise<{ status: "confirm" | "cancel" | "close"| "ok" }>(
      (resolve, reject) => {

        //第一步 判断是否填写过问题调查表
        getVisitorSurvey().then((res) => {
          if(res.data){
            // ElMessage.warning("您已经填写过问卷调查了，感谢您的参与！");
            resolve({
              status: "ok",
            }); 
          }else{
             ElMessageBox.confirm(
                i18n.global.t("当前账号不支持此功能，请升级账号信息！"),
                i18n.global.t("提示"),
                {
                  distinguishCancelAndClose: data?.isCert,
                  confirmButtonText: i18n.global.t("去升级"),
                  cancelButtonText: i18n.global.t("知道了"),
                  type: "warning",
                  lockScroll: false,
                }
              )
                .then(() => {
                  getLoginVisitorUpgrade().then(() => {
                    // store.dispatch("Login");
                    // window.open(
                    //   "https://wj.byteoversea.com/q/64377/7z6vI381/eda3/#/"
                    // );
                    resolve({
                      status: "confirm",
                    });
                  });
                })
                .catch((action: Action) => {
                  // reject();
                  console.log("action", action);
                  resolve({
                    status: action,
                  });
                });
          }
        });
 
      }
    );
  }
  return false;
}
/**生成随机字符串
 *
 * @param len 字符串生成长度 default 32
 * @returns 随机字符串
 */
export function randomString(len?: number) {
  len = len || 32;
  const $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678oOLl9gqVvUuI1";
  const maxPos = $chars.length;
  let pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
/** 获取当前用户是否符合代理商权限
 * @param classId string
 * @return {
 *  status:'noAuth'|'normal',
 *  isAuth:boolean
 * }
 */
export function authAgentAuth(classId: string): Promise<{
  isAuth: boolean;
  status: "normal" | "noAuth";
}> {
  return new Promise((resolve, reject) => {
    const resData: {
      isAuth: boolean;
      status: "normal" | "noAuth";
    } = {
      isAuth: false,
      status: "normal",
    };
    getDictList({ type: "class_flag_id" }).then((res) => {
      const successId = [] as string[];
      const userType = store.state.user.userInfo.type;
      res.data.forEach((item) => {
        successId.push(item.value);
      });
      console.log("successId", successId, successId.includes(classId));
      resData.isAuth = successId.includes(classId);
      if (resData.isAuth) {
        // tips.value = "此页面课程仅为代理商定制，非代理商身份不可用";
        if (!store.getters.isLogin) {
          store.dispatch("LoginBefore");
        } else {
          console.log('spStatus');
          console.log(store.state.user.userInfo.spStatus);
          if (store.state.user.userInfo.spStatus === 1) {
            resData.status = "normal";
            resolve(resData);
            return;
          }
          store.dispatch("GetInfo").then(() => {

            console.log('userType')
            console.log(userType)
            if (userType === "0") {
              // 游客
              resData.status = "noAuth";
              resolve(resData);
              return;
              // return (componentName.value = UpgradeAccount);
            } else if (userType === "3") {
              // 内部员工
              resData.status = "normal";
              resolve(resData);
              return;
              // return (componentName.value = CourseCenter);
            }
            // 1代理商 2品牌方
            const useType = store.state.user.userInfo.useType;
            console.log('useType');
            console.log(useType);
            postStudentSubjectInfo().then((res) => {
              console.log("有待审核信息吗", res.data);
              // 判断没有待审核信息
              if (!res.data || res.data.status === 1 || res.data.status === 2) {
                // 用户已经有输入信息完善
                if (useType) {
                  // 后台->代理商 用户->代理商
                  if (
                    (userType === "1" && useType === "1") ||
                    (userType === "4" && useType === "4") ||
                    (userType === "6" && useType === "6") ||
                    (userType === "6" && useType === "1") ||
                    (userType === "6" && useType === "4") 
                  ) {
                    // 审核通过 代理商
                    store.commit("SET_INFO_PERFECT_DIALOG", false);
                    // componentName.value = CourseCenter;
                    resData.status = "normal";
                    resolve(resData);
                  } else if (
                    userType === "1" &&
                    (useType === "2" || useType === "4")
                  ) {
                    // 后台->代理商 用户->品牌方 SEA代理商 需要二次弹窗
                    store.commit("SET_INFO_PERFECT_DIALOG", true);
                    // componentName.value = UpgradeAccount;
                    resData.status = "noAuth";
                    resolve(resData);
                  } else if (
                    userType === "4" &&
                    (useType === "2" || useType === "1")
                  ) {
                    // 后台->SEA代理商 用户->品牌方 代理商 需要二次弹窗
                    store.commit("SET_INFO_PERFECT_DIALOG", true);
                    // componentName.value = UpgradeAccount;
                    resData.status = "noAuth";
                    resolve(resData);
                  } else if (userType === "2" && useType === "2") {
                    // 后台->品牌方 用户->品牌方 展示无权限页面
                    store.commit("SET_INFO_PERFECT_DIALOG", false);
                    // componentName.value = UpgradeAccount;
                    resData.status = "noAuth";
                    resolve(resData);
                  } else if (
                    userType === "2" &&
                    (useType === "1" || useType === "4")
                  ) {
                    // 后台->品牌方 用户->代理商 SEA代理商
                    store.commit("SET_INFO_PERFECT_DIALOG", true);
                    // componentName.value = UpgradeAccount;
                    resData.status = "noAuth";
                    resolve(resData);
                  } else {
                    // componentName.value = UpgradeAccount;
                    resData.status = "noAuth";
                    resolve(resData);
                  }
                } else {
                  // 没有用户输入值&剩余审核次数为0
                  if (store.state.user.userInfo.num === 0) {
                    store.commit("SET_INFO_PERFECT_DIALOG", false);
                  } else {
                    store.commit("SET_INFO_PERFECT_DIALOG", true);
                  }
                  // componentName.value = UpgradeAccount;
                  resData.status = "noAuth";
                  resolve(resData);
                }
              } else {
                // 有待审核信息 用户之前输入为代理商
                store.commit("SET_INFO_PERFECT_DIALOG", true);
                // componentName.value = UpgradeAccount;
                resData.status = "noAuth";
                resolve(resData);
              }
            });
            // componentName.value = UpgradeAccount;
            // if (
            //   userType === "2" ||
            //   (userType === "1" && !store.state.user.userInfo.subject)
            // ) {
            //   componentName.value = UpgradeAccount;
            // } else {
            //   componentName.value = CourseCenter;
            // }
          });
        }
      } else {
        // tips.value = "";
        // componentName.value = CourseCenter;
        resData.status = "normal";
        resolve(resData);
      }
    });
  });
}
/** 判断当前域名是否是www.tiktokforbusiness-learning-center.com新域名
 * @returns boolean true表示是新域名，false表示不是新域名
 */
export function isNewDomain(): boolean {
  const hostname = window.location.hostname;
  return hostname === "www.tiktokforbusiness-learning-center.com";
}
